import { render, staticRenderFns } from "./BaseHistoryFileDetail.vue?vue&type=template&id=69974c46&scoped=true"
import script from "./BaseHistoryFileDetail.vue?vue&type=script&lang=js"
export * from "./BaseHistoryFileDetail.vue?vue&type=script&lang=js"
import style0 from "./BaseHistoryFileDetail.vue?vue&type=style&index=0&id=69974c46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69974c46",
  null
  
)

export default component.exports